/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';

import {Subject} from 'rxjs';

import {User} from '../models/user';

@Injectable()
export class UserDialogService {

  private mNewUserListeners = new Subject<any>();
  private mProfileListeners = new Subject<any>();
  private mEditUserListeners = new Subject<any>();
  private mRefreshUsersListeners = new Subject<any>();

  constructor(

  ) {}
  
  getNewUserListener(): Subject<any> {
    return this.mNewUserListeners;
  }
  
  getProfileListener(): Subject<any> {
    return this.mProfileListeners;
  }
  
  getEditUsersListeners(): Subject<any> {
    return this.mEditUserListeners;
  }
  
  getRefreshUsersListeners(): Subject<any> {
    return this.mRefreshUsersListeners;
  }
  
  createNewUser(): void {
    this.mNewUserListeners.next();
  }
  
  updateUserProfile(user: User): void {
    this.mProfileListeners.next({ "user" : user });
  }
  
  editUser(user: User): void {
    const event = { "user" : user };
    this.mEditUserListeners.next(event);
  }
  
  refreshUsers(): void {
    this.mRefreshUsersListeners.next();
  }

}
